window.slate = window.slate || {};
window.theme = window.theme || {};

//console.log(Currency.moneyFormats);

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */

slate.rte = {

  wrapTable: function() {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function() {
    var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="rte__video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '<span class="money">${{amount}}</span>';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
        // $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();



$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Wrap videos in div to force responsive layout.
  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  /*  ==========================================================================
      Init Currency Picker
      ========================================================================== */
  //initCurrencyPicker();

  /*  ==========================================================================
      currency if region specified
      ========================================================================== */

      var region = false;

      region = getQueryVariable('region');

      function getQueryVariable(variable){

          var query = window.location.search.substring(1);
          var vars = query.split("&");
          var region = false;
          for (var i=0;i<vars.length;i++) {
             var pair = vars[i].split("=");
             if(pair[0] == variable){ region = pair[1];}
          }
          return region;
      }

      if(region != false){
          var domain = wordpressurl.replace(/(^\w+:|^)\/\//, '');

          $.cookie(
              "horizoncurrency",
              region,
              {
                expires: 7,
                domain: 'horizonathletic.com',
                path: '/',
                secure: true
             }
         );

          $('.currency-picker').val(region.toUpperCase());

          $('.currency-picker').change();
      }

  /*  ==========================================================================
      currency if cookie is available
      ========================================================================== */
      var regioncookie = $.cookie('horizoncurrency');

      if(regioncookie != null){
          console.log(regioncookie);

          $('.currency-picker').val(regioncookie.toUpperCase());

          $('.currency-picker').change();
      }


  /*  ==========================================================================
      scroll to anchor
      ========================================================================== */

      $('a[href*="#"]')
          // Remove links that don't actually link to anything
          .not('[href="#"]')
          .not('[href="#0"]')
          .click(function(event) {
            // On-page links
            if (
              location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
              &&
              location.hostname == this.hostname
            ) {
              // Figure out element to scroll to
              var target = $(this.hash);
              target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
              // Does a scroll target exist?
              if (target.length) {
                // Only prevent default if animation is actually gonna happen
                event.preventDefault();
                $('html, body').animate({
                    scrollTop: target.offset().top - 84
                }, 1000);
              }
            }
    });

  /*  ==========================================================================
      update currency cookie
      ========================================================================== */

      $('.currency-picker').on('change', function() {
            console.log(this.value);
            var horizoncookie = $.cookie('horizoncurrency');
            var domain = 'horizonathletic.com';

            if(horizoncookie != null){
                $.cookie('horizoncurrency', this.value, { path: '/', domain: domain });
            }else{

                $.cookie(
                    "horizoncurrency",
                    this.value,
                    {
                      expires: 7,
                      path: '/',
                      domain: domain,
                      secure: true
                   }
               );

            }
        });

        var currencycookie = $.cookie('currency');

        console.log(currencycookie);
        if(currencycookie != null){

            var horizoncookie = $.cookie('horizoncurrency');
            console.log(horizoncookie);
            if(horizoncookie != currencycookie){

                var domain = 'horizonathletic.com';

                console.log(domain);

                if(horizoncookie != null){
                    $.cookie('horizoncurrency', this.value, { path: '/', domain: domain });
                }else{

                    console.log(this.value);

                    $.cookie(
                        "horizoncurrency",
                        currencycookie,
                        {
                          expires: 7,
                          path: '/',
                          domain: domain,
                          secure: true
                       }
                   );

                }

            }

        }

  /*  ==========================================================================
      Init Ajax Cart
      ========================================================================== */

  CartJS.init(foo, {
            "dataAPI": false,
            "requestBodyClass": "loading"
        }); // foo is a gloabal variable create in the theme.liquid to save the cart

 /*  ==========================================================================
     Load wordpress header
     ========================================================================== */
     /*  ==========================================================================
         Load wordpress header
         ========================================================================== */

//       //load_header();
//       function load_header(){
//           var url = wordpressurl + '/shopify/header.json';
//           $.ajax({
//             crossOrigin: true,
//             url: url,
//             proxy: wordpressurl + '/shopify/proxy.php',
//             context: {},
//             success: function(data) {
//                 //alert(data);
//                 $('.sitenavdropdown').append(data);
//                 // loadcart();
//                   $('body').addClass('sitenavdropdown--ready');
//               }
//           })
//           .done(function( data, textStatus, jqXHR ) {
//               //alert(data);
//           });
//       }

//       load_header_mobile();
//       function load_header_mobile(){
//         mobnav__init();
// //           var url = wordpressurl + '/shopify/mobile-header.json';
// //           $.ajax({
// //             crossOrigin: true,
// //             url: url,
// //             proxy: wordpressurl + '/shopify/proxy.php',
// //             context: {},
// //             success: function(data) {
// //                 //alert(data);
// //                // $('#mobnav').append(data);
// //                 mobnav__init();

// //               }
// //           })
// //           .done(function( data, textStatus, jqXHR ) {
// //               //alert(data);
// //           });
//       }


     // load_footer();
//       function load_footer(){
//           var url = wordpressurl + '/shopify/footer.json';
//           $.ajax({
//             crossOrigin: true,
//             url: url,
//             proxy: wordpressurl + '/shopify/proxy.php',
//             context: {},
//             success: function(data) {
//                 //alert(data);
//                 $footerwrapper = $('#footerwrapper');
//                 $footerwrapper.append(data);
//                 //footer__init();
//               }
//           })
//           .done(function( data, textStatus, jqXHR ) {
//               //alert(data);
//           });
//       }

    /*  ==========================================================================
        mobnav
        ========================================================================== */

        var $mobnavtoggle = $('.mobnav-toggle');
    	var mobnavopenclass = 'mobnavopen';
    	var $siteheader__bd = $('.siteheader__bd')

        function mobnav__init(){
    		mobnav__setmaxheight();

            $mobnavtoggle.on("click touchend",function (e) {
    	        e.preventDefault();
    			mobnav__setmaxheight();
    	        if ($('.mobnav').attr('data-status') != "open") {
    	            // it's not open
                  	$('body').find(".announcementsec").addClass("disnone");
    	            $('.mobnav').height($('.mobnav__bd').outerHeight(false)).attr('data-status', 'open');
    				$('body').addClass(mobnavopenclass);
    	        } else {
    	            // it's open
                  $('body').find(".announcementsec").removeClass("disnone");
    	            $('.mobnav').height(0).attr('data-status', 'closed');
    				$('body').removeClass(mobnavopenclass);
    	        }
    	    });

            $(window).resize(mobnav__resize);
        }
  		mobnav__init();

        function mobnav__resize() {
    		mobnav__setmaxheight();

    	    if ($('.mobnav').attr('data-status') == "open") {
    	        $('.mobnav').height($('.mobnav__bd').outerHeight(true)).attr('data-status', 'open');
    	    }

    	} // mobnav__resize()

    	function mobnav__setmaxheight(){
    		$('.mobnav').css("max-height", $( window ).height() - $siteheader__bd.outerHeight(false));
    	}

    /*  ==========================================================================
        sitenav
        ========================================================================== */

    	var $sitenav = $('.sitenavlist');
        var $sitenavitems = $('.sitenavitem > a', $sitenav).not('.hover--avoid');
    	var $sitenavdropdown = $('.sitenavdropdown');
    	var $sitenavsidepanel = $('.sitenavsidepanel');
    	var $sitenavsidepanelclose = $('.sitenavsidepanel__close');
    	var $cart = $('.shoppingcartcount');

    	var $sitenavitemsclick = $('.sitenavitem--click');

    	var $body = $('body');

    	var overclass = "over";
    	var navopenbodyclass = "sitenavopen";
    	var activesectionclass = "sitenavsection--active";
    	var navopen = false;
    	var $currentli = false;
    	var windowtimer = false;

    	sitenav__init();

    	//$('.sitenavlist li:first > a').trigger("mouseenter");

    	function sitenav__init(){

    		$(document).on({
      			mouseenter: sitenavitem__over
      		}, '.sitenavitem > a');

            $(document).on({
                mouseleave: sitenav__out
            }, '.sitenavitem > a');

            $(document).on({
                mouseover: sitenavsection__over,
                mouseleave: sitenav__out
            }, '.sitenavdropdown');

    	} // sitenav__init()

    	function sitenavitem__over(){

    		var $this = $(this);
    		var $targetsection = $('#sitenavsection--' + $this.attr('data-sitenavsection'));
    		if($this.attr('data-sitenavsection') == undefined){ return false; }

    		navopen = true;
    		if(windowtimer){ window.clearTimeout(windowtimer); }

    		$('.' + overclass, $sitenav).removeClass(overclass);
    		$this.addClass(overclass);
    		$body.addClass(navopenbodyclass);
    		$currentli = $this;

    		$('.' + activesectionclass).removeClass(activesectionclass);
    		$sitenavdropdown.css('height', $targetsection.outerHeight(false));
    		$targetsection.addClass(activesectionclass);

    	} // sitenavitem__over()

    	function sitenavsection__over(){
    		var $this = $(this);
    		navopen = true;
    		if(windowtimer){ window.clearTimeout(windowtimer); }

    		$body.addClass(navopenbodyclass);
    	} // sitenavitem__over()

    	function sitenav__out(){
    		navopen = false;
    		windowtimer = window.setTimeout(sitenav__close, 250);
    	} // sitenavitem__over()

    	function sitenav__close(){
    		if(!navopen){
    			$('.' + activesectionclass).removeClass(activesectionclass);
    			$body.removeClass(navopenbodyclass);
    			if($currentli){ $currentli.removeClass(overclass); }
    			$sitenavdropdown.css('height', 0);
    		}
    	} // sitenav__close


    /*  ==========================================================================
        links
        ========================================================================== */

        links__init();

    	function links__init($context){
    		$links = $('a').not('.pagination li > a, .btn, .noline, .noline a, .line--added');

    		$links.each(function(){
    			var $this = $(this);
    			var $icon = $('.fa', $this);

    			if($('img', $this).length < 1){
    				$this.wrapInner("<span class='linkline'>");
    				$this.addClass('line--added');
    				if($icon.length > 0){
    					if($icon.hasClass('fa--left')){
    						$icon.insertBefore($('.linkline', $this));
    					}else{
    						$icon.insertAfter($('.linkline', $this));
    					}
    				}
    			}
    		});
    	} // links__init()

    /*  ==========================================================================
        scrolled
        ========================================================================== */

    	$(document).scroll(function (evt) {
    		var y = $(this).scrollTop();
    		if (y > 50) {
    			$('body').addClass('hasscrolled');
    		} else {
    			$('body').removeClass('hasscrolled');
    		}
    	});
        $(document).scroll();

    /*  ==========================================================================
        productfilter
        ========================================================================== */

        var $filternav = $('.productfilternav');
        var $filternav_firstul = $('> ul', $filternav);
        var $filternav_firstul_li = $('> li', $filternav_firstul);
        var $filternav_firstul_a = $('> a', $filternav_firstul_li);
        var filternav_openclass = "active";

        if($filternav.length > 0){
            init__sortbyfilter(); // this is declared on product-filter.liquid
            filternav__init();
        }

        function filternav__init(){
            if(Modernizr.touch){
                console.log('is modernizr');
                $filternav_firstul_a.on("click tap", filternav__firsta__click);
            }else{
                $filternav_firstul_a.on("click tap touchend", function(e){ e.preventDefault(); });
                $filternav_firstul_li.on("mouseover mouseout", filternav__firsta__click);
            }

        } // filternav__init()


        function filternav__firsta__click(e){
            e.preventDefault();
            var $li = $(this).closest('li');

            console.log('click');

            if($li.hasClass(filternav_openclass)){
                $li.removeClass(filternav_openclass);
            }else{
                $('.' + filternav_openclass, $filternav).removeClass(filternav_openclass);
                $li.addClass(filternav_openclass);
            }

        } //filternav__firsta__click



    /*  ==========================================================================
        sharinglinks
        ========================================================================== */

    	$('.sharelink').click(function(e){
    		e.preventDefault();
    		window.open($(this).attr('href'), 'share-dialog', 'width=550,height=436');
    	});


    /*  ==========================================================================
        Product page
        ========================================================================== */

        /*  Product Gallery */
        function setupProductGallery(){
            if ($(".swiper-container").length > 0) {
                if ($(window).width() < 700) {
                    var productGallery = new Swiper('.swiper-container', {
//                         pagination: {
//                             el: '.swiper-pagination',
//                             type: 'fraction',
//                         },
                      pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
//                         renderBullet: function (index, className) {
//                             return '<span class="' + className + '">' + (menu[index]) + '</span>';
//                         },
                      },
                        spaceBetween: 30,
                    });
                }

                $(".swiper-container").imagesLoaded( function() {
            	       $body.addClass('productgallery--loaded');
                       fixingelements();
            	});
            }
        }
        setupProductGallery();

        var time;
        $(window).resize(function () {
            clearTimeout(time);
            time = setTimeout(function () {
                setupProductGallery();
            }, 50);
        });

        /*  Product Variant Select */
        $('.productdetail__select li').click(function(){
            if($(this).hasClass('disabled')) return false;

            var value = $(this).data('value'),
                id = $(this).data('id');

            // console.log('select id: '+ id );

            $('.productdetail__select li').removeClass('selected');
            $(this).addClass('selected');

            $('[data-single-option-selector]').val(value).trigger('change');

        });

        /*  Product Info Toggle */
        $('.productdetail__infotoggle [data-display]').click(function(){
            var display = $(this).data('display');

            $('.productdetail__infotoggle li').removeClass('selected');
            $('.productdetail__rte').removeClass('selected');

            $(this).addClass('selected');
            $('#'+display).addClass('selected');
        });


        /*  Fixing elements in product page */

        var positionThumbs = 'auto',
            positionLastImage = $('.productdetail__images .swiper-slide:last-child').position();

        function fixingelements(){

          	// Converted to position sticky
			/* $('.productdetail__images .swiper-slide:last-child').waypoint({
				handler: function(direction) {
                    var offsetLastImage = $('.productdetail__images .swiper-slide:last-child').position(),
                        offsetHeightImage = $('.productdetail__images .swiper-slide:last-child').outerHeight(),
                        thumbsHeight = $('.productdetail__thumnails').outerHeight();

                        // topThumbs = offsetLastImage.top + $('.productdetail__images .swiper-slide:last-child').outerHeight(true) - $('.productdetail__thumnails').outerHeight(true) + 3;
                        topThumbs = offsetLastImage.top;

                    if(direction == "down"){
                        $('.productdetail__thumnails').addClass('atbottom').css('top', 'calc(' + topThumbs + 'px + .5em)');
                    }else if(direction == "up"){
                        $('.productdetail__thumnails').removeClass('atbottom').css('top', positionThumbs);
                    }
                },
                //offset: 'bottom-in-view'
                offset: function() {

                    return $('.siteheader').height() + 9;
                    //return this.context.innerHeight() - this.adapter.outerHeight() - 80;
                }

			}); */

            $('.productdetail').waypoint({
                handler: function(direction) {
                    if(direction == "down"){
                        $('.productdetail__addtocart').addClass('atbottom');
                    }else if(direction == "up"){
                        $('.productdetail__addtocart').removeClass('atbottom');
                    }
                },
                offset: 'bottom-in-view'
            });

    	}// effects__init()

        function offset(el) {
            var rect = el.getBoundingClientRect(),
            scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
            scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
        }

        /*  Related products hide empty */
        if(!$.trim( $('.relatedproducts--match .producttiles').html() ).length){
            $('.relatedproducts--match').css('display','none');
            matchempty = true;
        }
        if(!$.trim( $('.relatedproducts--style .producttiles').html() ).length){
            $('.relatedproducts--style').css('display','none');
        }

        /*  ==========================================================================
            Ajax Cart
            ========================================================================== */

        loadEmptyCart = function() {
            var items = [],
                item = {},
                data = {},
                source = $("#CartEmpty").html(),
                template = Handlebars.compile(source);

            var $cartpanel = $('#sitenavsection--cart');
            $cartpanel.empty();

            $cartpanel.append(template(data));

            if($('#MainContent form.cart').length > 0){
                $('#pagecartcontent').empty();
                //if we are in the cart page refresh the items and price
                template = Handlebars.compile(source);
                $('#pagecartcontent').append(template(data));
            }
        }

        loadCart = function() {

            $.getJSON('/cart.js', function (cart, textStatus) {

                if(cart.item_count > 0){
                    $('.shoppingcartcount').attr('data-cartempty',false);
                }else{
                    $('.shoppingcartcount').attr('data-cartempty',true);
                    loadEmptyCart();
                    return;
                }

                var items = [],
                    item = {},
                    data = {},
                    moreitems = false,
                    source = $("#CartTemplate").html(),
                    template = Handlebars.compile(source);

                var $cartpanel = $('#sitenavsection--cart');
                $cartpanel.empty();
                //output = '<div class="cart__content"><div class="cart__items fontsize--sml">';

                $.each(cart.items, function(index, cartItem) {

                    if(index > 4) {
						moreitems = true;
						return;
					}

                    /* Hack to get product image thumbnail */
                    if (cartItem.image != null){
                        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
                    } else {
                        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
                    }

                    // console.log(cartItem);

                    // Create item's data object and add to 'items' array
                    item = {
                        id: cartItem.id,
                        key: cartItem.key,
                        line: index + 1, // Shopify uses a 1+ index in the API
                        url: cartItem.url,
                        img: prodImg,
                        name: cartItem.product_title,
                        variation: cartItem.variant_title,
                        properties: cartItem.properties,
                        itemAdd: cartItem.quantity + 1,
                        itemMinus: cartItem.quantity - 1,
                        itemQty: cartItem.quantity,
                        price: slate.Currency.formatMoney(cartItem.price, "${{amount}}"),
                        discountedPrice: slate.Currency.formatMoney((cartItem.price - (cartItem.total_discount/cartItem.quantity)), "${{amount}}"),
                        discounts: cartItem.discounts,
                        discountsApplied: cartItem.price === (cartItem.price - cartItem.total_discount) ? false : true,
                        vendor: cartItem.vendor
                    };

                    items.push(item);
                });
                // Gather all cart data and add to DOM
                data = {
                  items: items,
                  moreitems: moreitems,
                  note: cart.note,
                  totalPrice: slate.Currency.formatMoney(cart.total_price, "${{amount}}"),
                  totalCartDiscount: cart.total_discount === 0 ? 0 : slate.Currency.formatMoney(cart.total_discount, "£{{amount}}")
                };

                $cartpanel.append(template(data));

                //initCurrencyPicker();


                if($('#MainContent form.cart').length > 0){
                    items = [];
                    item = {};

                    $.each(cart.items, function(index, cartItem) {

                        /* Hack to get product image thumbnail */
                        if (cartItem.image != null){
                            var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
                        } else {
                            var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
                        }

                        // console.log(cartItem);

                        // Create item's data object and add to 'items' array
                        item = {
                            id: cartItem.id,
                            key: cartItem.key,
                            line: index + 1, // Shopify uses a 1+ index in the API
                            url: cartItem.url,
                            img: prodImg,
                            name: cartItem.product_title,
                            variation: cartItem.variant_title,
                            properties: cartItem.properties,
                            itemAdd: cartItem.quantity + 1,
                            itemMinus: cartItem.quantity - 1,
                            itemQty: cartItem.quantity,
                            price: slate.Currency.formatMoney(cartItem.price, "${{amount}}"),
                            discountedPrice: slate.Currency.formatMoney((cartItem.price - (cartItem.total_discount/cartItem.quantity)), "${{amount}}"),
                            discounts: cartItem.discounts,
                            discountsApplied: cartItem.price === (cartItem.price - cartItem.total_discount) ? false : true,
                            vendor: cartItem.vendor
                        };

                        items.push(item);
                    });
                    // Gather all cart data and add to DOM
                    data = {
                      items: items,
                      moreitems: moreitems,
                      note: cart.note,
                      totalPrice: slate.Currency.formatMoney(cart.total_price, "${{amount}}"),
                      totalCartDiscount: cart.total_discount === 0 ? 0 : slate.Currency.formatMoney(cart.total_discount, "£{{amount}}")
                    };

                    $('#pagecartcontent').empty();
                    //if we are in the cart page refresh the items and price
                    source = $("#CartPageTemplate").html();
                    template = Handlebars.compile(source);
                    $('#pagecartcontent').append(template(data));

                    // initCurrencyPicker();
                }

                //initCurrencyPicker();

            });
        }

        loadCart();

        // Add to Cart

        $('#addtoCartForm').submit(function(e) {
            e.preventDefault();
            var id = $('.productdetail__select li.selected').data('id');

            if(!id) return;

            CartJS.addItem(id, 1, {}, {

                // Define a success callback to display a success message.
                "success": function(data, textStatus, jqXHR) {

                    $('#message').addClass('message-success');
                    $('#message').html('Successfully added to cart.');
                  
                  	$('.shoppingcartcount').addClass("glow");
                  	$('.mobcart-toggle').addClass("glow");
        			$('.addtocart__cta .btn[data-add-to-cart]').addClass("added");
        			$('.addtocart__cta .btn[data-add-to-cart] span').html("Added to cart!");
                  
                  	setTimeout(function(){
                      $('.shoppingcartcount').removeClass("glow");
                      $('.mobcart-toggle').removeClass("glow");
                      $('.addtocart__cta .btn[data-add-to-cart]').removeClass("added");
                      $('.addtocart__cta .btn[data-add-to-cart] span').html("Add to Cart");
                    }, 2000);

                },

                // Define an error callback to display an error message.
                "error": function(jqXHR, textStatus, errorThrown) {
                    $('#message').addClass('message-error');
                    $('#message').html('There was a problem adding to the cart!');
                }


            });
        });

        // Update qty in cart

        $(document).on('click', '.cart__qty-adjust', function() {

            var id = $(this).data('id'),
                qty = $(this).data('qty'),
                qtyinput = $(this).siblings('.cart__qty-num'),
                qty__prev = qtyinput.val();

            CartJS.updateItemById(id, qty);

        });

        // Cart has changed callback

        $(document).on('cart.requestComplete', function(event, cart) {
            $body.addClass('cart--loading');

            // $('.shoppingcartcount span').html(slate.Currency.formatMoney(cart.total_price, "<span class=money>${{amount}}</span>"));
            $('.shoppingcartcount span').html('<span class="money">'+slate.Currency.formatMoney(cart.total_price, "${{amount}}")+'</span>');
            // $('.mobcart__count').html(slate.Currency.formatMoney(cart.total_price, "<span class=money>${{amount}}</span>"));
            //$('.mobcart__count').html('<span class="money">'+slate.Currency.formatMoney(cart.total_price, "${{amount}}")+'</span>');
          	$('.mobcart__count').html(cart.item_count);  
          	loadCart();
            updateVariantsInventory(cart);

            $body.removeClass('cart--loading');
        });

        updateVariantsInventory = function(cart) {

            var refresh = false;

            if(cart.item_count == 0){

                $('.productdetail__select li').each(function(){
                    if($(this).data('inventory') > 0){
                        $(this).removeClass('disabled');
                    }
                });
                refresh = true;

            }else{
                $('.productdetail__select li').each(function(){

                    var found = false,
                        $option = $(this);

                    $.each(cart.items, function(index, cartItem) {
                        if($option.data('id') == cartItem.id){
                            if($option.data('inventory') == cartItem.quantity){
                                if($option.hasClass('selected') || !$('.productdetail__select li.selected').length > 0) refresh = true;
                                $option.addClass('disabled').removeClass('selected');

                            }else{
                                $option.removeClass('disabled');
                            }
                            found = true;
                        }
                    });
                    // Item is not in cart
                    if(found == false){
                        $option.removeClass('disabled');
                    }
                });

                // Item is not in cart
                if(refresh == true){
                    $('.productdetail__select li:not(.disabled):first').trigger('click');
                }
            }
        }


    });
$(document).ready(function() {  
  $(".sitenavitem a").on('click', function(e) {  
      if ($(window).width() < 1026) {
    	e.preventDefault();
        var attr = $(this).attr('data-sitenavsection');
    	if (typeof attr !== typeof undefined && attr !== false) {
          var targetsection = 'sitenavsection--' + attr;
          if ($("body").find("#" + targetsection).hasClass("sitenavsection--active")) {
               window.location = $(this).attr('href');
          }
          $("body").removeClass("sitenaveopen");
          $(".sitenavdropdown").css("height","0px");
          $('.sitenavsection').removeClass("sitenavsection--active");


          $("body").find("#" + targetsection).addClass("sitenavsection--active");
          $("body").addClass("sitenaveopen");
          $(".sitenavdropdown").css({"height":"400px"});
          $("body").find("#" + targetsection).css({"height":"300px", "overflow":"scroll"});
        } else {
          	
        	window.location = $(this).attr('href');
        }
     } else {
    	  	window.location = $(this).attr('href');
     }
    
    });
});